import { Box, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Container, IconButton, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { motion, AnimatePresence } from 'framer-motion'
const CustomIcons = {
  EditAccount: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/></svg>
  ),
  ChangePassword: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
  ),
  AddressBook: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/></svg>
  ),
  Wishlist: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
  ),
  Order: (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>
  ),
  // Download: (props) => (
  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>
  // ),
  // RMA: (props) => (
  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"/></svg>
  // ),
  // Transaction: (props) => (
  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>
  // ),
  // Newsletter: (props) => (
  //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
  // ),
}
const MyAccount = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const accountFunctions = [
    { title: 'Edit Account',path:'/my/edit-account', icon: CustomIcons.EditAccount, color: theme.palette.address.edit, gradient: `linear-gradient(135deg, ${theme.palette.address.edit} 0%, ${theme.palette.address.edit_dark} 100%)` },
    { title: 'Change Password',path:'/my/update-password', icon: CustomIcons.ChangePassword, color: theme.palette.address.password, gradient: `linear-gradient(135deg, ${theme.palette.address.password} 0%, ${theme.palette.address.password_dark} 100%)` },
    { title: 'Address Book',path:'/my/address-book', icon: CustomIcons.AddressBook, color: theme.palette.address.address_book, gradient: `linear-gradient(135deg, ${theme.palette.address.address_book} 0%, ${theme.palette.address.address_book_dark} 100%)` },
    { title: 'Wishlist',path:'/my/wish-list', icon: CustomIcons.Wishlist, color: theme.palette.address.wishlist, gradient: `linear-gradient(135deg, ${theme.palette.address.wishlist} 0%, ${theme.palette.address.wishlist_dark} 100%)` },
    { title: 'Order',path:'/my/order-history', icon: CustomIcons.Order, color: theme.palette.address.history, gradient: `linear-gradient(135deg, ${theme.palette.address.history} 0%, ${theme.palette.address.wishlist_dark} 100%)` },
    // { title: 'Download',path:'/my/downloads', icon: CustomIcons.Download, color: '#4FD1C5', gradient: 'linear-gradient(135deg, #4FD1C5 0%, #81E6D9 100%)' },
    // { title: 'RMA',path:'/my/rma', icon: CustomIcons.RMA, color: '#FC8181', gradient: 'linear-gradient(135deg, #FC8181 0%, #FEB2B2 100%)' },
    // { title: 'Transaction',path:'/my/transaction', icon: CustomIcons.Transaction, color: '#F687B3', gradient: 'linear-gradient(135deg, #F687B3 0%, #FBB6CE 100%)' },
    // { title: 'Newsletter',path:'/my/news-letter', icon: CustomIcons.Newsletter, color: '#222222', gradient: 'linear-gradient(135deg, #222222 0%, #474747 100%)' },
  ]
  
  const StyledCard = styled(motion.div)(({ theme }) => ({
    background: theme.palette.tertiary.bg_address,
    backdropFilter: 'blur(10px)',
    borderRadius: '10px',
    border: `1px solid ${theme.palette.tertiary.bg_address}`,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    height: '100%',
    width: '100%',
    '&:hover': {
    transform: 'translateY(-5px)', 
    boxShadow: `0 10px 20px ${theme.palette.tertiary.shadow_address}`, 
  },
  }));
  
  
  const IconWrapper = styled('div')(({ theme }) => ({
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    position: 'relative',
    zIndex: 1,
  }))
  const cardVariants = {
    initial: { opacity: 0, y: 50 }, 
    animate: { opacity: 1, y: 0 }, 
  };
  
  const transition = {
    type: "spring", 
    stiffness: 150,
    damping: 15,
    duration: 0.5, 
  };
  const myAccount = [
    {
      label: 'Edit your account information',
      path: '/my/edit-account',
    },
    {
      label: 'Change your password',
      path: '/my/update-password',
    },
    {
      label: 'Modify your address book entries',
      path: '/my/address-book',
    },
    {
      label: 'Modify your wish list',
      path: '/my/wish-list',
    },
  ];

  const myOrders = [
    {
      label: 'View your order history',
      path: '/my/order-history',
    },
    {
      label: 'View your return requests',
      path: '/my/return-requests',
    },
    {
      label: 'Your Transactions',
      path: '/my/transactions',
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent:'start',
        alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',
        height: 'auto',
        flexGrow: 1,
        gap: 1, 
      }}
    >
      {/* <BackgroundAnimation
          animate={{
            backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
          }}
          transition={{
            duration: 20,
            ease: 'linear',
            repeat: Infinity,
          }}
        /> */}
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        
        <Grid container spacing={4}>
  {accountFunctions.map((func, index) => (
    <Grid item xs={12} sm={6} md={4} key={index}
    onClick={() => handleNavigation(func.path)}
    >
      <motion.div
        variants={cardVariants}
        initial="initial"
        animate="animate"
        transition={transition}
        style={{ height: '100%', display: 'flex' }}
      >
        <StyledCard>
          <IconWrapper style={{ background: func.gradient }}>
            <func.icon style={{ width: '40px', height: '40px', color: theme.palette.tertiary.main }} />
          </IconWrapper>
          <Typography variant="h6" component="div" align="center" sx={{ color: theme.palette.heading_color.main, fontWeight: 'bold', mb: 1 }}>
            {func.title}
          </Typography>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: func.gradient,
              opacity: 0.1,
              zIndex: 0,
            }}
          />
        </StyledCard>
      </motion.div>
    </Grid>
  ))}
</Grid>
        </Container>
      {/* <Typography
        variant="h4"
        sx={{
          color: theme.palette.heading_color.main,
          fontWeight: 600,
          fontSize: { xs: 20, sm: 24 },
        }}
      >
        My Account
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5, 
        }}
      >
        {myAccount.map((item, index) => (
          <Typography
            key={index}
            variant="body1"
            onClick={() => handleNavigation(item.path)}
            sx={{
              color: theme.palette.text.secondary,
              fontSize: { xs: 14, sm: 16 },
              cursor: 'pointer',
              '&:hover': {
                color: theme.palette.secondary.main, 
              },
            }}
          >
            {item.label}
          </Typography>
        ))}
      </Box>

      <Typography
        variant="h4"
        sx={{
          color: theme.palette.heading_color.main,
          fontWeight: 600,
          fontSize: { xs: 20, sm: 24 },
        }}
      >
        My Orders
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5, 
          flexGrow: 1,
        }}
      >
        {myOrders.map((item, index) => (
          <Typography
            key={index}
            variant="body1"
            onClick={() => handleNavigation(item.path)}
            sx={{
              color: theme.palette.text.secondary,
              fontSize: { xs: 14, sm: 16 },
              cursor: 'pointer',
              '&:hover': {
                color: theme.palette.secondary.main, 
              },
            }}
          >
            {item.label}
          </Typography>
        ))}
      </Box> */}
    </Box>
  );
};

export default MyAccount;
